/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Wrapped_Muscles_CountInputs */

const en_us2_wrapped_muscles_count = /** @type {(inputs: Wrapped_Muscles_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 muscle trained`);
	return /** @type {LocalizedString} */ (`${i?.count} muscles trained`)
	
};

const pt_br2_wrapped_muscles_count = /** @type {(inputs: Wrapped_Muscles_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 músculo trabalhado`);
	return /** @type {LocalizedString} */ (`${i?.count} músculos trabalhados`)
	
};

const es_419_wrapped_muscles_count = /** @type {(inputs: Wrapped_Muscles_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 músculo trabajado`);
	return /** @type {LocalizedString} */ (`${i?.count} músculos trabajados`)
	
};

const pt_pt2_wrapped_muscles_count = /** @type {(inputs: Wrapped_Muscles_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 músculo trabalhado`);
	return /** @type {LocalizedString} */ (`${i?.count} músculos trabalhados`)
	
};

const fr_fr2_wrapped_muscles_count = /** @type {(inputs: Wrapped_Muscles_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 muscle travaillé`);
	return /** @type {LocalizedString} */ (`${i?.count} muscles travaillés`)
	
};

const de_de2_wrapped_muscles_count = /** @type {(inputs: Wrapped_Muscles_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Muskel trainiert`);
	return /** @type {LocalizedString} */ (`${i?.count} Muskeln trainiert`)
	
};

const it_it2_wrapped_muscles_count = /** @type {(inputs: Wrapped_Muscles_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 muscolo allenato`);
	return /** @type {LocalizedString} */ (`${i?.count} muscoli allenati`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 muscle trained" |
* | * | "{count} muscles trained" |
*
* @param {Wrapped_Muscles_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_count = /** @type {((inputs: Wrapped_Muscles_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_count(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_count(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_count(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_count(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_count(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_count(inputs)
	return en_us2_wrapped_muscles_count(inputs)
});
export { wrapped_muscles_count as "wrapped.muscles_count" }